import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { AppBar, Hidden, IconButton, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { RoutePaths } from '@shared/utils';
import { AccountButton } from '../accountButton';
import { useStyles } from './styles';

interface Props {
  onToggleDrawer: () => void;
}

export const Header = (props: Props) => {
  const location = useLocation();
  const routes = useMemo(() => RoutePaths.getRoutes(), []);

  const classes = useStyles();

  return (
    <AppBar position='static' className={classes.appBar}>
      <Toolbar>
        <Hidden lgUp>
          <IconButton className={classes.menuButton} color='inherit' size='large' onClick={props.onToggleDrawer}>
            <MenuIcon />
          </IconButton>
        </Hidden>
        <div className={classes.title}>
          <Typography variant='h6' color='inherit'>
            {routes.find((route) => location.pathname.includes(`/${route.path}`))?.title || ''}
          </Typography>
        </div>
        <AccountButton color='inherit' />
      </Toolbar>
    </AppBar>
  );
};
